import React from 'react'
import { getSite } from '@shared/Frontend/utils/site'
import { RootView } from '../../../libraries/root/root.template'

const site = getSite()

export const SiteFooter: RootView['SiteFooter'] = ({ children, menuOpen }) => (
  <>
    <footer id="a11y-footer" className="sitefooter sf" inert={menuOpen ? '' : undefined}>
      {site == 'ZEG' && ( 
      <svg className="sf__blob" width="846" height="866" viewBox="0 0 846 866" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M556.942 590.612C282.298 812.707 161.795 911.718 55.6682 843.982C-115.972 734.42 154.468 287.912 344.563 126.477C563.589 -59.534 745.023 -16.1473 819.878 110.336C914.523 270.235 723.018 456.322 556.942 590.637V590.612Z" stroke="#346DAC" stroke-width="2" stroke-miterlimit="10"/>
      </svg>
      )}

      {site == 'ZEG' ? ( 
        <svg className='sf__shape' width="1920" height="150" viewBox="0 0 1920 150" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1920 149.539C1456.52 31.418 958.472 -21.0557 605.49 7.74255C368.46 27.0754 167.431 72.2704 0 136.639V150H1920V149.539Z" fill="#012169"/></svg>
      ) : (
        <svg className='sf__shape' width="1920" height="140" viewBox="0 0 1920 140" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 140H1920V40.1445C1784.42 41.1254 1602.3 78.8766 1442.2 111.713C1215.9 158.194 794.766 122.416 523.519 81.1846C324.053 50.8679 155.935 2.58767 20.3438 0H0V140Z" fill="#012169"/></svg>
      )}      

      <div className='sf__outer'>
        <div className="sf__inner ls-container ls-gutter">
          {children}
        </div>
      </div>
    </footer>
  </>
)
